import React from "react";
import CrudPage from "@/components/CrudPage";
import { Badge } from "@/components/Common";
import { useAuth } from "@/context/AuthContext";
import { fmtEuro } from "@/lib/constants";
import { DOCENTE_FIELDS, RUOLI_PERSONALE, contrattoLabel, cobWarning } from "@/lib/anagrafiche";

const FILTERS = [
  { name: "ruoli", label: "Ruolo", options: RUOLI_PERSONALE, allLabel: "docenti e tutor" },
  { name: "competenze", label: "Competenza", optionKey: "competenze" },
];

const RuoliBadges = ({ r }) => (
  <div className="flex flex-wrap gap-1" data-testid="ruoli-badges">
    {["docente", "tutor"].filter((v) => (r.ruoli?.length ? r.ruoli : ["docente"]).includes(v)).map((v) => (
      <Badge key={v} label={v === "tutor" ? "Tutor" : "Docente"} cls={v === "tutor" ? "bg-violet-50 text-violet-700 border-violet-200" : "bg-amber-50 text-amber-700 border-amber-200"} />
    ))}
  </div>
);

export default function Docenti() {
  const { user } = useAuth();
  const cols = [
    { key: "nome", label: "Nominativo", render: (r) => <span className="font-medium text-slate-900 hover:text-[#E11D48]">{r.cognome} {r.nome}</span> },
    { key: "ruoli", label: "Ruolo", render: (r) => <RuoliBadges r={r} /> },
    { key: "cf", label: "CF / P.IVA", render: (r) => <span className="font-mono text-xs">{r.piva || r.cf}</span> },
    { key: "tipo_contratto", label: "Contratto", render: (r) => r.tipo_contratto ? <Badge label={contrattoLabel(r.tipo_contratto)} cls="bg-slate-100 text-slate-600 border-slate-200" /> : "—" },
    { key: "competenze", label: "Competenze", render: (r) => (r.competenze || []).slice(0, 2).join(", ") || "—" },
  ];
  if (user?.can_economics) cols.push({ key: "tariffa_oraria", label: "Tariffa/h", render: (r) => <span className="font-semibold">{r.tariffa_oraria ? fmtEuro(r.tariffa_oraria) : "—"}</span> });

  return (
    <CrudPage
      title="Personale (docenti e tutor)"
      subtitle="Docenti e tutor: anagrafiche, contratti, tariffe e competenze"
      endpoint="docenti"
      testid="docenti-page"
      detailRoute="docenti"
      cfAutofill
      validate={cobWarning}
      filters={FILTERS}
      columns={cols}
      fields={DOCENTE_FIELDS}
    />
  );
}
